import lineChart from './lineChart';

const pnlChart = {
  options: {
    ...lineChart.options,
    yaxis: {
      labels: {
        style: {
          fontSize: '14px',
          fontWeight: 600,
          colors: ['#8c8c8c'],
        },
        formatter: (value) => {
          return `${Math.round(value * 100) / 100}%`;
        },
      },
    },
    tooltip: {
      x: {
        format: 'yyyy-MM-dd HH:mm',
      },
      y: {
        formatter: function (val) {
          return `${val}%`;
        },
      },
    },
  },
};

export default pnlChart;
